// @flow
import React, { Component } from 'react';
import renderHTML from 'react-render-html';

type Props = {
  content: string;
  className: void | string;
};

class Description extends Component<void, Props, void> {
  render() {
    const className = ['description', this.props.className]
      .filter(Boolean)
      .join(' ');

    return (
      <div className={className}>
        {renderHTML(this.props.content)}
      </div>
    );
  }
}

export default Description;



// WEBPACK FOOTER //
// ./src/components/Description/index.jsx